/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S9_P1Inputs */

const tr_mesafeli_s9_p1 = /** @type {(inputs: Mesafeli_S9_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform, abonelik planına dahil veya ek krediyle satın alınan modeller aracılığıyla yapay zekâ destekli özellikler sunmaktadır (otomatik fiyatlama, müşteri yanıtı taslakları, kategori önerisi vb.).`)
};

const en_mesafeli_s9_p1 = /** @type {(inputs: Mesafeli_S9_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Platform offers artificial intelligence powered features through models included in the subscription plan or purchased with additional credits (automatic pricing, customer reply drafts, category suggestions, etc.).`)
};

const de_mesafeli_s9_p1 = /** @type {(inputs: Mesafeli_S9_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Plattform bietet über Modelle, die im Abonnementplan enthalten sind oder mit zusätzlichen Credits erworben werden, durch künstliche Intelligenz unterstützte Funktionen an (automatische Preisgestaltung, Entwürfe für Kundenantworten, Kategorievorschläge usw.).`)
};

const ru_mesafeli_s9_p1 = /** @type {(inputs: Mesafeli_S9_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформа предоставляет функции с поддержкой искусственного интеллекта посредством моделей, включённых в план подписки или приобретённых за дополнительные кредиты (автоматическое ценообразование, черновики ответов клиентам, предложения категорий и т. п.).`)
};

/**
* | output |
* | --- |
* | "The Platform offers artificial intelligence powered features through models included in the subscription plan or purchased with additional credits (automatic..." |
*
* @param {Mesafeli_S9_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s9_p1 = /** @type {((inputs?: Mesafeli_S9_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S9_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s9_p1(inputs)
	if (locale === "de") return de_mesafeli_s9_p1(inputs)
	if (locale === "ru") return ru_mesafeli_s9_p1(inputs)
	return tr_mesafeli_s9_p1(inputs)
});